import Request from '../../../../src/core/gd/data/request'
import Office from "../../model2/office/office";

export default class ApiOffice{

    static getOffice(id: ID){
        return new Request(this,'GET','company/offices/'+id);
    }

    static create(name: string, ipAddresses: string){
        return new Request(this,'POST','company/offices/create', {
            name: name,
            ipAddresses: ipAddresses,
            // comment: comment ? comment : ""
        });
    }
    static saveSortPosition(ids: ID[]){
        return new Request(this,'PUT','company/offices/create', {
            officeIds: ids
        });
    }

    static update(id: ID, name: string, ipAddresses: string){
        return new Request(this,'PUT','company/offices/'+id, {
            name: name,
            ipAddresses: ipAddresses,
            // comment: comment ? comment : ""
        });
    }

    static updateV2(id: ID, payload:any){
        return new Request(this,'PUT','company/offices/'+id, payload);
    }

    static createV2(payload:any){
        return new Request(this,'POST','company/offices/create', payload);
    }

    static deleteOffice(id: ID){
        return new Request(this,'DELETE','company/offices/'+id);
    }

}
